import React from "react";
import Box from "@material-ui/core/Box";
import { useTranslation } from "react-i18next";

import { makeStyles } from "@material-ui/core/styles";
import withWidth, { isWidthUp } from "@material-ui/core/withWidth";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
}));

function MapControl({ children, width, position, drawerWidth, openDrawer, ...other }) {
  const classes = useStyles();

  let style = {
    position: "absolute",
    left: isWidthUp("sm", width) ? (openDrawer ? (drawerWidth + 10) : 10) : 10,
    zIndex: 1100,
    backgroundColor: 'transparent',
    width: !isWidthUp("sm", width) ? "96%" : undefined 
  }

  if (!position || position === 'top') style.top = 10
  else if (position === 'bottom') style.bottom = 10

  return (
    <Box
      display="flex"
      flexDirection="row"
      flexWrap="wrap"
      style={ style }
    >
      {children}
    </Box>
  );
}

export default withWidth()(MapControl);